import React, { useEffect } from 'react';
import Image from '../AppImage';

const CompanyBranding = ({ company = {} }) => {
  const {
    name = 'Company Name',
    logo = null,
    primaryColor = '#2563EB',
    secondaryColor = '#64748B'
  } = company;

  React.useEffect(() => {
    if (primaryColor) {
      document.documentElement?.style?.setProperty('--color-primary', primaryColor);
    }
    if (secondaryColor) {
      document.documentElement?.style?.setProperty('--color-secondary', secondaryColor);
    }

    return () => {
      document.documentElement?.style?.removeProperty('--color-primary');
      document.documentElement?.style?.removeProperty('--color-secondary');
    };
  }, [primaryColor, secondaryColor]);

  return (
    <div className="company-branding-header">
      <div className="flex items-center gap-4">
        {logo ? (
          <Image
            src={logo}
            alt={`${name} logo`}
            className="company-branding-logo"
          />
        ) : (
          <div
            className="h-12 w-12 rounded-lg flex items-center justify-center text-white font-semibold text-xl"
            style={{ backgroundColor: primaryColor }}
          >
            {name?.charAt(0)?.toUpperCase()}
          </div>
        )}
        <div>
          <h1 className="text-xl font-semibold text-text-primary">{name}</h1>
          <p className="text-sm text-text-secondary">Company Dashboard</p>
        </div>
      </div>
    </div>
  );
};

export default CompanyBranding;